export const IRENE_MODEL_OPTIONS = [
  { value: "gpt-6-luna", label: "Luna" },
  { value: "gpt-6.1-sol", label: "GPT-6.1 Sol" },
];

export const IRENE_SOL_EFFORT_OPTIONS = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "xhigh", label: "Extra High" },
];

export function parseIreneModelSettings(value) {
  const settings = value == null || value === ""
    ? { model: "gpt-6-luna", reasoning_effort: "none" }
    : typeof value === "string" ? JSON.parse(value) : value;
  if (!settings || typeof settings !== "object" || Array.isArray(settings)
      || Object.keys(settings).sort().join(",") !== "model,reasoning_effort"
      || !IRENE_MODEL_OPTIONS.some(({ value: model }) => model === settings.model)) {
    throw new Error("Invalid Irene model settings");
  }
  const validEffort = settings.model === "gpt-6.1-sol"
    ? IRENE_SOL_EFFORT_OPTIONS.some(({ value: effort }) => effort === settings.reasoning_effort)
    : settings.reasoning_effort === "none";
  if (!validEffort) throw new Error("Invalid reasoning effort for Irene's model");
  return { model: settings.model, reasoning_effort: settings.reasoning_effort };
}

export async function loadIreneModelSettings(client) {
  const data = await client.get("/settings");
  return parseIreneModelSettings(data.settings?.irene_cloud_runtime?.value);
}

export async function saveIreneModelSettings(client, settings) {
  const validated = parseIreneModelSettings(settings);
  const data = await client.put("/settings", {
    settings: { irene_cloud_runtime: JSON.stringify(validated) },
  });
  if (data.results?.irene_cloud_runtime?.success !== true) {
    throw new Error(data.results?.irene_cloud_runtime?.error || "Irene model settings were not saved");
  }
  return validated;
}